//Registration - Error
export const REGISTRATION_EXISTING_ACCOUNT = "409";
